import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackRemoveAllConfirm } from './tracking';
import { removeAll } from '../../../actions/favoriteEntities';
import { ModalFooter } from '../../../components/MassActions/remove/ModalFooter';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { selectEntityTypeText } from '../../../selectors/filters/selectEntityTypeText';
import { selectSelectedProducts } from '../../../selectors/selected';
import { getConfirmText } from '../../../utils/remove';

interface IProps {
  onClose(): void;
}

export function ModalConfirmRemoveAllContainer({ onClose }: IProps) {
  const dispatch = useDispatch();
  const selectedProducts = useSelector(selectSelectedProducts);
  const entityType = useSelector(selectEntityTypeText);

  const handleConfirm = () => {
    trackRemoveAllConfirm(selectedProducts);
    dispatch(removeAll());
    onClose();
  };

  return (
    <ModalConfirm
      text={getConfirmText(entityType)}
      footer={<ModalFooter onConfirm={handleConfirm} onCancel={onClose} />}
      onClose={onClose}
      isVisible={true}
    />
  );
}
